var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{staticClass:"header",on:{"click-left":_vm.onClickLeft}},[_c('div',{staticClass:"back",attrs:{"slot":"left"},slot:"left"},[_c('van-icon',{attrs:{"name":"arrow-left"}}),_vm._v(" 返回 ")],1),_c('div',{staticStyle:{"color":"#ffffff"},attrs:{"slot":"title"},slot:"title"},[_vm._v("授权赋权")])])
}
var staticRenderFns = []

export { render, staticRenderFns }